export function periodToDate(year, month) {
	const nextYear = Number(year);
	const nextMonth = Number(month);
	if (
		!Number.isInteger(nextYear) ||
		!Number.isInteger(nextMonth) ||
		nextMonth < 1 ||
		nextMonth > 12
	) {
		return null;
	}
	return new Date(nextYear, nextMonth - 1, 1);
}

export function dateToPeriod(value) {
	if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
		return { year: '', month: '' };
	}
	return {
		year: String(value.getFullYear()),
		month: String(value.getMonth() + 1),
	};
}
